// "A new version is available" banner, after sogni-web's UpdateBanner.
//
// sogni-web drives this from its service worker, which notices index.html
// changed. That works there because every Vite build rewrites the markup with
// new hashed script names. This app serves raw ES modules at stable names, so
// the markup is identical across deploys and a service worker would have
// nothing to react to. Instead the server fingerprints the files it serves and
// this polls that fingerprint — same UX, no extra cache layer to go stale.

const POLL_MS = 120_000;

const banner = document.getElementById('update-banner');
const reloadBtn = document.getElementById('update-reload');
const dismissBtn = document.getElementById('update-dismiss');

let current = null;
let dismissed = false;
let timer = null;

async function fetchBuildId() {
  try {
    const res = await fetch('/api/version', { cache: 'no-store' });
    if (!res.ok) return null;
    return (await res.json())?.buildId || null;
  } catch {
    return null; // offline or mid-deploy; try again later
  }
}

function show() {
  if (dismissed) return;
  banner.classList.remove('hidden');
}

async function check() {
  const id = await fetchBuildId();
  if (!id) return;
  if (current === null) {
    current = id;
    return;
  }
  if (id !== current) {
    show();
    clearInterval(timer); // nothing more to learn once it is up
  }
}

export function startUpdateWatch() {
  if (!banner) return;
  reloadBtn.onclick = () => window.location.reload();
  dismissBtn.onclick = () => {
    dismissed = true;
    banner.classList.add('hidden');
  };
  check();
  timer = setInterval(check, POLL_MS);
  // Coming back to a tab left open overnight is exactly when this matters, and
  // waiting out the interval there would show stale code for another two
  // minutes.
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') check();
  });
}
